import { useEffect, useState } from "react";
import "./FadeAlert.css";

const FadeAlert = ({ response, resetResponse, children }) => {
    const [visible, setVisible] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        if (response && Object.keys(response).length > 0) {
            setVisible(true);
            setFadeOut(false);

            const timer = setTimeout(() => {
                handleClose(); // Авто закрытие
            }, 10000);

            return () => clearTimeout(timer);
        }
    }, [response, resetResponse]);

    const handleClose = () => {
        setFadeOut(true);
        setTimeout(() => {
            setVisible(false);
            resetResponse();
        }, 1000); // 1 сек для анимации
    };

    if (!visible) return null;

    return (
        <div className={`alert alert-success fade-alert ${fadeOut ? "fade-out" : "fade-in"}`} role="alert" style={{ position: "relative" }}>
            {children}
            <button
                onClick={handleClose}
                style={{
                    position: "absolute",
                    top: "8px",
                    right: "12px",
                    background: "transparent",
                    border: "none",
                    fontSize: "1.2rem",
                    cursor: "pointer",
                    color: "#000"
                }}
                aria-label="Close"
            >
                &times;
            </button>
        </div>
    );
};

export default FadeAlert;
